import { gql } from '@apollo/client'

const SB_ACCOUNTS_FRAGMENT = gql`
  fragment SBAccountFields on SBAccount {    
    id
    client_id
    email
    is_available
    created_at
    updated_at
  }
`

export default SB_ACCOUNTS_FRAGMENT